export default __webpack_public_path__ + "static/img/ig_contact_4.8f51f2c.png";